import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const useStyles = makeStyles(() => ({
  button: {
    width: '50%',
    margin: 'auto',
    left: '25%',
  },
}));

const FitlersMenu = ({ ...props }) => {
  const classes = useStyles();
  const { availableFields, filtermenuopen, handleCloseFilters, savedFilters } = props;
  const mutableFilters = savedFilters || availableFields;
  const localFilters = mutableFilters.map((field) => {
    if (savedFilters) {
      return {
        field: field.label,
        id: field.id,
        filter: field.filter,
        checked: field.checked,
      };
    } else {
      return {
        field: field.label,
        id: field.id,
        filter: 'Filter...',
        checked: false,
      };
    }
  });

  const handleClickChkBx = (e) => {
    const availableField = e.target.value;
    const found = localFilters.find((value) => {
      return value.field === availableField;
    });
    if (found) {
      const i = localFilters.indexOf(found);
      localFilters[i].checked = !localFilters[i].checked;
    }
  };

  const handleFilterChange = (e, availableField) => {
    const found = localFilters.find((value) => {
      return value.field === availableField;
    });

    if (found) {
      const i = localFilters.indexOf(found);
      localFilters[i].filter = e.target.value;
      localFilters[i].checked = true;
    }
  };

  return (
    <>
      <Dialog
        open={filtermenuopen}
        onClose={(e) => {
          handleCloseFilters(e, savedFilters);
        }}
      >
        <div style={{ margin: 'auto', padding: '1vw' }}>
          <DialogTitle>Select Your Filter(s) Below: </DialogTitle>
          <FormControl style={{ paddingBottom: '3%', width: '-webkit-fill-available' }}>
            <FormGroup name="radio-buttons-group">
              {mutableFilters &&
                mutableFilters.map((availableField, i) => {
                  return (
                    <>
                      <Accordion key={availableField.id}>
                        <AccordionSummary
                          key={availableField.id}
                          expandIcon={<ExpandMoreIcon key={availableField.id} />}
                        >
                          <FormControlLabel
                            key={availableField.id}
                            value={availableField.label}
                            control={
                              <Checkbox
                                key={availableField.id}
                                onClick={handleClickChkBx}
                                defaultChecked={availableField.checked}
                              />
                            }
                            label={availableField.label}
                          />
                        </AccordionSummary>
                        <AccordionDetails key={availableField.id}>
                          <TextField
                            key={availableField.id}
                            autoFocus
                            placeholder={savedFilters ? availableField.filter : 'Enter Filters...'}
                            fullWidth
                            onBlur={(e) => {
                              handleFilterChange(e, availableField.label);
                            }}
                          />
                        </AccordionDetails>
                      </Accordion>
                    </>
                  );
                })}
            </FormGroup>
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={(e) => {
              handleCloseFilters(e, []);
            }}
          >
            Reset Filters
          </Button>
          <br />
          <br />
          <div>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={(e) => {
                handleCloseFilters(e, localFilters);
              }}
            >
              Apply
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default FitlersMenu;
